import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-biens-comparables-vendus-edit-mode',
  templateUrl: './biens-comparables-vendus-edit-mode.component.html',
  styleUrls: ['./biens-comparables-vendus-edit-mode.component.scss'],
})
export class BienComparablesVendusEditModeComponent implements OnChanges {
  @Input() references!: Report.References;
  @Input() reportType!: string;

  @Output() referencesChanged = new EventEmitter<Report.References>();

  newReferences!: Report.References;

  ngOnChanges(changes: SimpleChanges): void {
    const currentReferences = changes['references'].currentValue;
    if (currentReferences) {
      this.newReferences = currentReferences;
      this.setFormValues();
    }
  }

  isDisplayModeDetailledChanged(isDisplayModeDetailled: boolean): void {
    this.newReferences = {
      ...this.newReferences,
      isDisplayModeDetailled,
    };

    this.referencesChanged.emit(this.newReferences);
  }

  isConfidentialChanged(isConfidential: boolean): void {
    this.newReferences = {
      ...this.newReferences,
      isConfidential,
    };

    this.referencesChanged.emit(this.newReferences);
  }

  isSelectionChanged(isSelection: boolean): void {
    this.newReferences = {
      ...this.newReferences,
      isSelection,
    };

    this.referencesChanged.emit(this.newReferences);
  }

  private setFormValues(): void {}
}
